// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavItem_navItem__2dE2X","link":"NavItem_link__3ikN_","itemLogo":"NavItem_itemLogo__1EkSx"};